module.exports = __webpack_public_path__ + "media/assets/images/flags/mc-5bd0f4b0b0f54ef6d82731aa22fbb7ae.svg";